import React from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"
import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { TEST_IDS } from "~config/constants"

import SidebarFeatureLockIndicator from "./sidebar-feature-lock-indicator"
import { useSharedStyles } from "./sidebar-styles"

interface Props {
    readonly icon?: IconProp
    readonly isActiveItem?: boolean
    readonly isFeatureBlocked?: boolean
    readonly isSidebarCollapsed?: boolean
}

export default function SidebarIcon({
    icon,
    isActiveItem,
    isFeatureBlocked,
    isSidebarCollapsed,
}: Props) {
    const styles = useStyles({ isActiveItem })

    if (isFeatureBlocked && isSidebarCollapsed) {
        return <SidebarFeatureLockIndicator />
    }

    return (
        <Box style={styles.iconContainer}>
            {icon && (
                <FontAwesomeIcon
                    data-testid={TEST_IDS.SIDEBAR_ICON}
                    style={styles.icon}
                    icon={icon}
                />
            )}
        </Box>
    )
}

function useStyles({ isActiveItem }: { isActiveItem?: boolean }) {
    const { label } = useSharedStyles({ isActiveItem })

    return componentStyles({
        iconContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginX: 3,
            borderRadius: "lg",
        },
        icon: {
            ...label,
        },
    })
}
